/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};

  function VideoSection($section) {
      // Extend the instance with section data
      $.extend(this, window.PXUTheme.getSectionData($section));

      
      // Store selectors as properties
      this.$section = $section;
      this.$videoElement = $section.find('[data-video-element]');
      this.$playIcon = $section.find('.plyr--paused.plyr--video .plyr__control--overlaid');
      this.$deferredPlayButton = $section.find('.deferred-play-button');
      this.$playButton = $section.find('[data-play-button]');
      this.$videoTextContainer = $section.find('[data-video-text-container]');
      this.$imageElement = $section.find('[data-image-element]');

      // Initialize the video
      this.init();
  }

  VideoSection.prototype.init = function() {
      if (this.html5_video) {
        this.loadVideo();
      } else if (this.iframe_video) {
        this.deferredLoading();
      } else {
        this.$imageElement.show();
      }
  };

  // Immediate loading for HTML5 type
  VideoSection.prototype.loadVideo = function() {

    const {
      $videoElement,
      $playIcon,
      $playButton,
      $videoTextContainer,
      $imageElement
    } = this;


    const player = new Plyr(`.video-${this.id}`, {
      controls: videoControls,
      loop: {
        active: this.autoloop
      },
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });

    player.muted = this.mute;
    player.ratio = this.aspect_ratio;

    // If autoplay enabled, hide image and text
    if (this.autoplay) {
        player.autoplay = true;
        $imageElement.hide();
        $videoTextContainer.hide();
        $videoElement.show();
    } else {
      // If autoplay disabled, check if poster image added
      if (this.poster) {
          $videoElement.hide();
          $imageElement.show();
          $videoTextContainer.show();
      } else {
        // If autoplay disabled and no poster image
          $imageElement.hide();
          $videoElement.show();
          $videoTextContainer.show();
      }
    }        
    
    if (this.button) {
        $playButton.on('click', () => {
        player.play();
      });
    }

    if (!this.button) {
        $videoTextContainer.on('click', () => {
        player.play();
      });
    }

    if (!isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media')) {
        $imageElement.on('click', () => {
        player.play();
      });
    }

  // On player ready, hide play icon if play button visible
  player.on('ready', function(index, player) {
      if ($playButton && !isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media')) {
        $playIcon.show();
      } else if ($playButton) {
        $playIcon.hide();
      } else {
        $playIcon.show();
      }
  })    
  
  player.on('play', () => {
  });

  player.on('pause', () => {
    if (!$playButton) {
      $playIcon.show();
    }
  });

  };

  // Deferred Loading for iframe types
  VideoSection.prototype.deferredLoading = function() {
      const {
        $videoElement,
        $deferredPlayButton,
        $videoTextContainer,
        $imageElement,
      } = this;

      const $thumbnail = $imageElement.find('img.youtube-thumbnail');
  
      if ($thumbnail.length > 0) {

        $thumbnail.on('load', function() {
            console.log('Original thumbnail loaded:', this.src);
          
          if (this.naturalWidth <= 120) {
            console.log('Placeholder detected. Replacing with new image.');
        
            // Create a new image element
            const $newThumbnail = $thumbnail.clone();

            const newSrc = this.src.replace('maxresdefault.jpg', 'sddefault.jpg');
            $newThumbnail.attr('src', newSrc);
            
            // Remove Maxres from the srcset
            const $newSrcset = $newThumbnail.attr('srcset').split(',').slice(1).join(',').trim();
            $newThumbnail.attr('srcset', $newSrcset)

            console.log('Trimmed srcset:', $newSrcset);
      
            // Remove lazyloading classes
            $newThumbnail.attr('class', 'youtube-thumbnail'); 

      
            // Attach event handlers to the new image
            $newThumbnail.on('load', function() {
              console.log('New thumbnail loaded successfully:', this.src);
              // Proceed with any additional logic
            });

            $thumbnail.replaceWith($newThumbnail);

          }
        })
      }
  
      // Define injectIframeAndLoadVideo as an arrow function
      const injectIframeAndLoadVideo = (e) => {
        // Inject the iframe and load the video
        const template = $videoElement.find('template')[0];
  
        if (!template) {
          console.error('Template not found');
          return;
        }
  
        const iframe = document.importNode(template.content, true);
        $(template).remove(); // Remove the template
        $videoElement.empty().append(iframe);

        // Remove deferred play button
        $deferredPlayButton.remove();
        $imageElement.hide();
        $videoTextContainer.hide();
        $videoElement.show();
        
        // Remove event listener
        $videoTextContainer.off('click', injectIframeAndLoadVideo);

      };
  
      // Attach event listener
      $videoTextContainer.on('click', injectIframeAndLoadVideo);
  };


  // Update global object to use the constructor
  window.PXUTheme.jsVideo = {
      init: function($section) {
      new VideoSection($section);
      },
      unload: function($section) {
      // Implement unload logic if needed
      }
  };

  
  /******/ })()
  ;